module.exports = __webpack_public_path__ + "6ab6bba36765f4668f381986a5dde4b0.svg";